import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';

import { CoreConfig } from '@app/core/plugin';
import { CoreStateService } from '@app/core/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  public readonly config$: Observable<CoreConfig>;

  public isScrollTop = true;

  constructor(private coreStateService: CoreStateService) {
    this.config$ = this.coreStateService.state$;
  }

  @HostListener('window:scroll', ['$event'])
  public windowScroll() {
    this.isScrollTop = !window.pageYOffset;
  }
}
